import {
  HttpEvent,
  HttpContextToken,
  HttpContext
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { KeycloakCustomService } from '../services/keycloak-custom.service';
import { DataService } from '../services/data.service';

const SEND_MODIFIED_BY_BODY = new HttpContextToken<boolean>(() => false);
export function sendBodyModifiedBy() {
  return new HttpContext().set(SEND_MODIFIED_BY_BODY, true);
}

const SEND_MODIFIED_BY_QUERY = new HttpContextToken<boolean>(() => false);
export function sendQueryModifiedBy() {
  return new HttpContext().set(SEND_MODIFIED_BY_QUERY, true);
}

@Injectable()
export class UserModifiedInterceptor implements HttpInterceptor {

  constructor(
    private keycloakCustomService: KeycloakCustomService,
    private dataService: DataService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.context.get(SEND_MODIFIED_BY_BODY) && !req.context.get(SEND_MODIFIED_BY_QUERY)) {
      return next.handle(req);
    }

    let email = this.dataService.idKeycloak;
    const isSalesfoceLoggin = this.keycloakCustomService.isLoggedIn();
    if (isSalesfoceLoggin && this.keycloakCustomService.salesforceEmail) {
      email = this.keycloakCustomService.salesforceEmail;
    }

    let request = req;
    if (req.context.get(SEND_MODIFIED_BY_BODY)) {
      request = request.clone({
        body: { ...request.body, modifiedBy: email }
      });
    } else if (req.context.get(SEND_MODIFIED_BY_QUERY)) {
      request = request.clone({
        setParams: {
          modifiedBy: email
        }
      });
    }
    return next.handle(request);
  }
}
